import { Request } from '@/classes/Request.ts'

export interface AutoPayTermsStatusResponse {
  latestTerms: String
  signatureRequired: boolean
  termsId: number
}

export const autoPayTermsStatus = async (): Promise<AutoPayTermsStatusResponse> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/auto_pay/terms_status`)
      .then(result => {
        resolve({
          latestTerms: result.data.latest_terms,
          signatureRequired: result.data.signature_required,
          termsId: result.data.terms_id
        } as AutoPayTermsStatusResponse)
      })
      .catch(err => {
        reject(err)
      })
  })
}
